import axios from 'axios';

const httpClient = axios.create({
  paramsSerializer: {
    // Escape the following characters just to be safe
    encode: (val) =>
      val
        .replace(/%/gi, '%25')
        .replace(/\[/gi, '%5B')
        .replace(/\]/gi, '%5D')
        .replace(/\$/gi, '%24'),
  },
});

// adds access tokens in all api requests
// this interceptor is only added when the auth0 instance is ready and exports the getAccessTokenSilently method
export const addAccessTokenInterceptor = (getAccessTokenSilently) => {
  httpClient.interceptors.request.use(async (config) => {
    const newConfig = config;
    const { audience } = window.globalConfig.auth0;
    const token = await getAccessTokenSilently({
      authorizationParams: { audience },
    });
    newConfig.headers.Authorization = `Bearer ${token}`;
    return newConfig;
  });
};

export default httpClient;
